function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useRef, useEffect, useCallback, useState, useLayoutEffect } from 'react';
var useTruncate = _ref => {
  var font = _ref.font,
    fontSize = _ref.fontSize,
    optionPadding = _ref.optionPadding,
    globalPadding = _ref.globalPadding;
  var canvasContext = useRef();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    containerRef = _useState2[0],
    setContainerRef = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    width = _useState4[0],
    setWidth = _useState4[1];
  useEffect(() => {
    var canvas = document.createElement('canvas');
    canvasContext.current = canvas.getContext('2d');
    if (canvasContext.current) {
      canvasContext.current.font = font;
    }
  }, [font]);
  var updateWindowDimensions = useCallback(() => {
    if (containerRef) {
      var newWidth = containerRef.getBoundingClientRect().width;
      if (width !== newWidth) {
        setWidth(newWidth);
      }
    }
  }, [containerRef]); // eslint-disable-line react-hooks/exhaustive-deps

  useLayoutEffect(() => {
    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);
    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
    };
  }, [updateWindowDimensions]);
  var getTextWidth = text => canvasContext.current ? canvasContext.current.measureText(text).width : text.length * fontSize;
  var truncate = function truncate(values) {
    var additional = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (values.length < 2 || additional && values.length < 3) {
      return values;
    }
    var padding = values.length * optionPadding + globalPadding;
    var text = values.map(value => value.name).join('');
    var textWidth = getTextWidth(text);
    if (textWidth + padding >= width) {
      var lastValueIndex = values.length - (additional ? 2 : 1);
      var lastValue = values[lastValueIndex];
      var subitems = additional ? values[values.length - 1].subitems : [];
      return truncate([...values.slice(0, lastValueIndex), {
        name: "+ ".concat(additional + 1, " location").concat(additional > 0 ? 's' : ''),
        subitems: [lastValue, ...subitems],
        overflow: true
      }], additional + 1);
    }
    return values;
  };
  return {
    truncate,
    containerRef: setContainerRef
  };
};
export default useTruncate;